import { create } from 'zustand'

interface RecruiterSubscriptionModalState {
  isOpen: boolean
  showModal: () => void
  hideModal: () => void
}

export const useRecruiterSubscriptionModal = create<RecruiterSubscriptionModalState>((set) => ({
  isOpen: false,
  showModal: () => set({ isOpen: true }),
  hideModal: () => set({ isOpen: false }),
}))
